export let dto_MobileAppCategory = {
  BusinessType: String,
  CountryCode: String,
  CSP: String,
  Inactive: Boolean,
  MACID: Number,
  MACImageUrl: String,
  MACOrder: Number,
  MobileAppCategory: String,
  ListType: Number
};